<template>
	<div>
		<template v-for="effectProps of effectsData">
			<div
				:class="rowClasses(effectProps)"
				:title="fullPropertyName(effectProps)"
			>
				<div
					class="Modifier__effect-property-name"
					v-html="truncatedPropertyName(effectProps)"
				></div>
				<div class="Modifier__effect-visualization">
					<!-- @vue-expect-error -->
					<percent-from-center-bar
						v-if="!hidePercentFromCenterBar"
						:value="effectProps.value"
						:min="property.min_modifying_value"
						:srv-middle="0"
						:max="property.max_modifying_value"
						:increase-is-desirable="property.is_desirable"
					></percent-from-center-bar>
					<colored-trend-arrow
						v-if="onlyShowTrend"
						:value="effectProps.value"
						:property="property"
						:target-actor="effectProps.target_actor"
					></colored-trend-arrow>
				</div>
				<div
					v-if="!onlyShowTrend"
					class="Modifier__effect-value text-right"
					:title='effectProps.value + (propertyValueUnit && propertyValueUnit.length > 1 ? " " : "") + propertyValueUnit'
				>
					{{ shortHumanValue(effectProps) }}
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import ColoredTredArrow from "../global_components/graphs_and_visualizations/colored_trend_arrow.vue";
// Other components
import PercentFromCenterBar from "../global_components/graphs_and_visualizations/percent_from_center_bar.vue";
import { i18n } from "../utils";

export default {
	mixins: [i18n],
	props: {
		property: Object,
		effectsData: Object,
		itemId: String,
		hidePercentFromCenterBar: Boolean,
		onlyShowTrend: Boolean,
	},
	components: {
		"percent-from-center-bar": PercentFromCenterBar,
		"colored-trend-arrow": ColoredTredArrow,
	},
	computed: {
		locale() {
			return I18n.locale;
		},
		propertyValueUnit() {
			// @ts-expect-error
			return this.property.value_units[I18n.locale] || "";
		},
		allActorProperties() {
			// @ts-expect-error
			return VueStore.getters.actorsPropertiesOfType(this.property.type_key);
		},
		appendTargetActor() {
			// No need to show the target Actor's name if there is only one Actor with Properties in the Game
			return Object.keys(VueStore.getters.actorsProperties()).length > 1;
		},
	},
	mounted() {
		pp.vue.bus.$on("measure-effect-preview", (payload) => {
			this.handleIncoming(payload);
		});
	},
	beforeDestroy() {
		// pp.log("before destr", this, this.$el);
		pp.vue.bus.$off("measure-effect-preview");
	},
	methods: {
		rowClasses(effectProps) {
			let toReturn = "Modifier__effect-row";
			if (effectProps.value == 0) {
				toReturn += " Modifier__effect-row--zero-val";
			}
			if (this.hidePercentFromCenterBar) {
				toReturn += " Modifier__effect-row--hide-percent-from-center-bar";
			}
			return toReturn;
		},
		fullPropertyName(effectProps) {
			// @ts-expect-error
			let toReturn = this.property.names[I18n.locale];
			if (!this.appendTargetActor) {
				return toReturn;
			}
			return toReturn + this.targetActorName(effectProps);
		},
		truncatedPropertyName(effectProps) {
			// @ts-expect-error
			let toReturn = this.property.names[I18n.locale].truncate(
				this.hidePercentFromCenterBar ? 60 : 22,
			);
			if (!this.appendTargetActor) {
				return toReturn;
			}
			const toAppend = this.targetActorName(effectProps);
			return (
				toReturn +
				(this.onlyShowTrend || this.hidePercentFromCenterBar ? "" : "<br>") +
				toAppend
			);
		},
		targetActorName(effectProps) {
			if (effectProps.target_actor) {
				const currentActor = VueStore.getters.actorData(pp.currentActorId);
				// Only show target Actor's name if there is enough space (i.e. if `onlyShowTrend`) and if the target Actor is not the current Actor's (principal) group
				if (
					currentActor &&
					![currentActor.groupIds, pp.currentActorId]
						.flat()
						.includes(effectProps.target_actor)
				) {
					return ` (${VueStore.getters.actorData(effectProps.target_actor).names[I18n.locale]})`;
				}
			}
			return ""; // Else
		},
		shortHumanValue(effectProps) {
			let toReturn = effectProps.value_abbr;
			// @ts-expect-error
			const valueUnit = this.property.value_units[I18n.locale];
			if (valueUnit) {
				if (valueUnit != "%") {
					toReturn += " ";
				}
				toReturn += valueUnit.truncate(5);
			}
			return toReturn;
		},
		handleIncoming(payload) {
			// Example:
			// `pp.vue.bus.$emit("measure-effect-preview", itemId: "in-list--prop-68988-measure-495457", [{value: 123, value_abbr: "123"}])`
			// pp.log("test", payload.itemId, this.itemId, this.$el)
			if (payload.itemId != this.itemId) {
				return;
			}
			// pp.log("setting", this.$el, this.property.names, JSON.stringify(payload.effectsData));
			// @ts-expect-error
			this.effectsData = payload.effectsData;
		},
	},
};
</script>
